module.exports = __webpack_public_path__ + "img/sr.df432653.svg";